import checkHasUtmProperties from '@shared/lib/utils/checkHasUtmProperties'

const isInvalidUrlOrUTMPropertiesInUrlChecker = (value: string) => {
  return !value || checkHasUtmProperties(value)
}

export default isInvalidUrlOrUTMPropertiesInUrlChecker
